module.exports = "https://coursera_assets.s3.amazonaws.com/images/44cda02a71807a3b5648bfc7d97bb08d.png";